module.exports = __webpack_public_path__ + "static/dev-79cb0b7e82b9553b6a17928307dba9de.svg";